import type { ComponentType, LazyExoticComponent, ReactNode } from 'react';

export type FormDrawerParams = Record<string, unknown>;
export type FormDrawerTitleResolver = (params: FormDrawerParams) => string;
export type FormDrawerBadgeResolver = (params: FormDrawerParams) => string | undefined;
export type FormDrawerIconResolver = (params: FormDrawerParams) => ReactNode;

export interface FormDrawerRegistryEntry {
  title: string | FormDrawerTitleResolver;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  icon?: ReactNode | FormDrawerIconResolver;
  badge?: string | FormDrawerBadgeResolver;
  component: LazyExoticComponent<ComponentType<FormDrawerParams>>;
}

/** Stable keys → lazy drawer content. Add entries as features ship. */
export const formDrawerRegistry: Record<string, FormDrawerRegistryEntry> = {};

export type FormDrawerKey = string;

export function getFormDrawerTitle(
  entry: FormDrawerRegistryEntry,
  params: FormDrawerParams,
): string {
  if (typeof entry.title === 'function') {
    return entry.title(params);
  }

  return entry.title;
}

export function getFormDrawerBadge(
  entry: FormDrawerRegistryEntry,
  params: FormDrawerParams,
): string | undefined {
  if (entry.badge === undefined) {
    return undefined;
  }

  if (typeof entry.badge === 'function') {
    return entry.badge(params);
  }

  return entry.badge;
}

export function getFormDrawerIcon(
  entry: FormDrawerRegistryEntry,
  params: FormDrawerParams,
): ReactNode | undefined {
  if (entry.icon === undefined) {
    return undefined;
  }

  if (typeof entry.icon === 'function') {
    return entry.icon(params);
  }

  return entry.icon;
}
